<template src="./templates/Keywords.html" />

<script setup>

import {
    useQueryParamsStore,
} from '@timezoneone/dottie-client-jam';

const queryParams = useQueryParamsStore();

</script>
